<template>
  <div class="web">
    <footer>
      <div>
          <div class="d-flex flex-row justify-content-evenly">
              <div class=" politicas">
                  <div>
                      <h4>Políticas de uso</h4>
                  </div>

                  <ul class="list-unstyled">
                      <div class="d-flex flex-row">
                          <div class="flex-col">
                              <li><a :href="urlWeb+ '/assets/pdf/acuerdoUsuario.pdf'">Acuerdo de usuario</a></li>
                              <li><a :href="urlWeb+ '/assets/pdf/codigoConducta.pdf'">Código de conducta</a></li>
                              <li><a :href="urlWeb+ '/assets/pdf/politicaPrivacidad.pdf'">Política de privacidad</a>
                              </li>
                              <li><a :href="urlWeb+ '/assets/pdf/formatoFacturacion.docx'">Formato de facturación</a></li>
                          </div>
                          <div class="flex-col pl-4">
                              <li><a :href="urlWeb+ '/assets/pdf/politicaVerificacionidentidad.pdf'">Política de
                                      verificación de identidad</a></li>
                              <li><a :href="urlWeb+ '/assets/pdf/politicaCargosTarifas.pdf'">Política de cargos y
                                      tarifas</a></li>
                          </div>
                          <div class="flex-col pl-3">
                            <li>
                                <router-link to="/Contacto">Contacto</router-link>
                              </li>
                              <li >
                                <router-link to="/Faq" >FAQ</router-link>
                              </li>
                          </div>
                      </div>
                  </ul>
              </div>
              <div class="siguenos ml-2">
                  <div class="col">
                      <h4>Síguenos</h4>
                  </div>
                  <div class="d-flex flex-column align-items-center social-icons">
                    <div class="d-flex flex-row justify-content-evenly" style="width: 100%;">
                      <a target="_blank" href="https://twitter.com/ITSAPPLLC"><img class="mb-3" :src="urlWeb + '/assets/icons/twitter.png'"
                              alt="X Twitter" ></a>
                      <a target="_blank" href="https://www.facebook.com/itSAPpLLC/"><img class="mb-3" :src="urlWeb + '/assets/icons/facebook.png'"
                              alt="Facebook" ></a>
                    </div>
                    <div class="d-flex flex-row justify-content-evenly" style="width: 100%;">
                      <a target="_blank" href="https://www.linkedin.com/company/it-sap-p/"><img  class="mb-3" :src="urlWeb + '/assets/icons/linkedin.png'"
                              alt="Linked In" ></a>
                      <a target="_blank" href="https://www.youtube.com/@itSAPp-rava69"><img  class="mb-3" :src="urlWeb + '/assets/icons/youtube.png'"
                              alt="Youtube" ></a>
                    </div>
                  </div>
              </div>
              <div class="contactanos ml-2">
                  <h4>Contáctanos</h4>
                  <div class="d-flex social-icons">
                      <a target="_blank" href="https://wa.me/14694127111"><img :src="urlWeb + '/assets/images/fotos/qr_wp.png'"
                              alt="X Twitter"></a>
                      <a target="_blank" href="https://t.me/share/url?to=14694127111"><img
                              :src="urlWeb + '/assets/images/fotos/qr_tg.png'" alt="X Twitter"></a>
                  </div>
              </div>
          </div>
      </div>
    </footer>
  </div>  
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed:{
    ...mapState(['urlWeb'])
},
  name: 'Footer',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.foot{
    background-color: #4a5562;
    height: 75px;
    color: white;
    width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue